var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallTtLogo = function SvgSmallTtLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#697477",
    d: "m22 5.278-22 12.5v4.444l9.075-5.156V27.5l3.85-2.187V14.879L22 9.722z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3AACC8",
    d: "M9.075 0v10.434L0 5.278v4.444l5.967 3.39 6.958-3.953V2.187zM16.033 14.387l-2.008 1.141v2.163L22 22.222v-4.444z"
  })));
};
export { SvgSmallTtLogo as ReactComponent };
export default __webpack_public_path__ + "6db4203dc12919c2589d65bca953471e.svg";